import { withFormik } from "formik";
import * as Yup from "yup";

const ResetPasswordEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    newpassword: Yup.string()
      .required("Please enter new password")
      .min(8, "Password must be of at least 8 characters in length")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter"),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
      .required("Please Enter Confirm Password")
  }),
  mapPropsToValues: props => ({
    newpassword: "",
    confirmpassword: ""
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default ResetPasswordEnhancer;
